// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__vmsQ7","list":"BalanceDue_list__2mR3G","listRow":"BalanceDue_listRow__2RT1S","total":"BalanceDue_total__3jsPP"};